export default {
  scrollBarWidth: 16,
  thresholds: {
    xs: 600,
    sm: 768,
    md: 1280,
    lg: 1920,
  },
};